<template>
  <div class="login">
    <h1>Handling logging in...</h1>
  </div>
</template>

<script>

export default {
  name: 'keycloak-login-callback',
  beforeMount() {
    this.$store.dispatch('loginKeycloak', this.$keycloak.token);
  },
};

</script>
